<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasTradeStatusType="true"
      :hasReportSourceType="true"
      :hasFoodStatusType="true"
      :hasBusinessClass="true"
      :hasCostType="true"
      :hasStore="true"
      :hasEmployee="true"
      :hasCustomer="true"
      :hasFoodMajorKind="true"
      :hasFoodKind="true"
      :hasFood="true"
      :hasTerminal="true"
      :hasFoodSupplier="isERP"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :hasRankType="true"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    >
      <div class="row" v-if="chartData.rows.length > 0" slot="middleArea">
        <div class="col-md-6">
          <div class="card card-table card-body">
            <ve-histogram :data="chartData" :settings="chartSettings" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-table card-body">
            <ve-pie :data="chartData"></ve-pie>
          </div>
        </div>
      </div>
    </condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      isERP: window.localStorage["isERP"] == "true",
      items: [],
      pagination: {},
      columns: [
        { name: "FoodKindNumber" },
        { name: "FoodKindName" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "FoodName2" },
        { name: "Barcode" },
        { name: "BusinessClass" },
        { name: "Qty" },
        { name: "Times" },
        { name: "Unit" },
        { name: "Total" },
        { name: "GrossProfit" },
        { name: "GrossMargin" },
        { name: "SaleProportion" },
        { name: "SalPrice" },
        { name: "TotalCost" },
        { name: "NTaxPrice" },
        { name: "YTaxPrice" },
        { name: "ZTaxPrice" },
        { name: "TaxPrice" },
        { name: "TaxType" },
      ],
      chartSettings: {
        labelMap: {
          Qty: "數量",
          Total: "金額",
        },
        axisSite: { right: ["Total"] },
        yAxisType: ["normal", "KMB"],
        yAxisName: ["數量", "金額"],
      },
      chartData: {
        columns: ["FoodName", "Qty", "Total"],
        rows: [],
      },
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getFoodSaleStatistic(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getFoodSaleStatistic(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printFoodSaleStatistic(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getFoodSaleStatistic(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
        vm.chartData.rows = data.Datas;
      });
    },
  },
};
</script>
